<template>
	<modal
		:exibir="exibir"
		titulo="Enviar Fornecedor"
		:max-width="500"
		:is-confirmar-visivel="true"
		:custom-actions="false"
		:acao-confirmar="enviarFornecedor"
		nome-botao-confirmar="Enviar"
		:acao-cancelar="fecharModal"
		:is-confirmar-desabilitado="desabilitarAcaoEnviarFornecedor"
		@close="fecharModal"
	>
		<template #body>
			<v-row dense class="az-form-content cp-modal-form-content">
				<v-col cols="12" class="pb-0">
					<label-personalizado nome-campo="E-mail"></label-personalizado>
					<v-text-field
						id="emailFornecedor"
						v-model.trim="model.emailFornecedor"
						v-validate="'email'"
						name="E-mail"
						type="text"
						dense
						placeholder="E-mail do fornecedor"
						:error-messages="errors.collect('E-mail')"
					>
						<template #message="{ message, key }">
							<span class="message-error">{{ message }}</span>
						</template>
					</v-text-field>
				</v-col>
			</v-row>
		</template>
	</modal>
</template>

<script>
import LabelPersonalizado from '@/views/components/LabelPersonalizado.vue'
import Modal from '@/views/components/Modal.vue'

export default {
	name: 'modal-enviar-fornecedor',
	components: { Modal, LabelPersonalizado },
	inject: ['$validator'],
	props: {
		exibir: {
			type: Boolean,
			required: true,
		},
		idAssociacao: {
			type: Number,
			required: true,
		},
		emailFornecedor: {
			type: String,
			required: true,
		},
	},
	emits: ['fechar-modal', 'enviar-fornecedor'],
	data() {
		return {
			model: {
				emailFornecedor: this.emailFornecedor,
			},
		}
	},
	computed: {
		desabilitarAcaoEnviarFornecedor() {
			return !this.ehFormularioValido || !this.ehEmailPreenchido
		},
		ehEmailPreenchido() {
			return this.model.emailFornecedor !== null && this.model.emailFornecedor.trim().length > 0
		},
		ehFormularioValido() {
			return this.errors.items.length === 0
		},
	},
	methods: {
		fecharModal() {
			this.$emit('fechar-modal')
		},
		async enviarFornecedor() {
			this.$emit('enviar-fornecedor', {
				emailFornecedor: this.model.emailFornecedor,
				idDocumento: this.idAssociacao,
			})
		},
	},
}
</script>

<style scoped lang="stylus"></style>
